var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h1", { staticClass: "title" }, [
      _vm._v(
        " " +
          _vm._s(
            _vm.$t("pages.pickup_management.mail_observer.blocked_mails")
          ) +
          " "
      ),
    ]),
    _c(
      "span",
      { staticClass: "mb-2" },
      [
        _c(
          "b-button",
          {
            staticClass: "button is-warning",
            attrs: {
              "icon-left": "sync",
              disabled: _vm.loading || !_vm.selectedGroup.collectGroup,
            },
            on: { click: _vm.loadData },
          },
          [_vm._v(" " + _vm._s(_vm.$t("global.refresh")) + " ")]
        ),
      ],
      1
    ),
    _vm.result
      ? _c(
          "div",
          { staticClass: "mt-2 box" },
          _vm._l(_vm.result, function (obj, index) {
            return _c("div", { key: index, staticClass: "mb-4" }, [
              _c("article", { staticClass: "message is-danger" }, [
                _c(
                  "div",
                  { staticClass: "message-header is-size-4" },
                  [
                    _vm._v(" " + _vm._s(obj.email) + " "),
                    _c("b-tag", { attrs: { size: "is-medium" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$dayjs(obj.created).format("DD/MM/YYYY HH:mm")
                          ) +
                          " "
                      ),
                    ]),
                  ],
                  1
                ),
                _c("div", { staticClass: "message-body" }, [
                  _vm._v(" " + _vm._s(obj.reason) + " "),
                ]),
              ]),
            ])
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }